import React, { Component } from "react";

import { connect } from "react-redux";
import {
    Button,
    Form,
    FormGroup,
    Input,
    InputGroup
} from "reactstrap";

import { Link } from "react-router-dom";

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

//Import i18n
import { withTranslation } from "react-i18next";

//Import Megamenu

// Redux Store
import { toggleRightSidebar } from "../../store/actions";
import { Grid } from "@mui/material";

//Import logo Images

//Import Social Profile Images

class ToggleMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearch: false,
            isSocialPf: false,
        };
        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleRightbar = this.toggleRightbar.bind(this);
        this.toggleFullscreen = this.toggleFullscreen.bind(this);
    }
    /**
 * Toggle sidebar
 */
    toggleMenu() {
        this.props.toggleMenuCallback();
    }

    /**
     * Toggles the sidebar
     */
    toggleRightbar() {
        this.props.toggleRightSidebar();
    }


    toggleFullscreen() {
        if (
            !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                );
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }
    render() {
        return (
            <React.Fragment>
                <header id="page-topbar" style={{ width: "30px", height: "60px" }}>
                    <div className="navbar-header" style={{ marginRight: "100px" }} >
                        <Grid container className="navbar-brand-box-breadcrumb">
                            <Button
                                size="sm"
                                color="none"
                                type="button"
                                className="px-3 font-size-24 header-item waves-effect"
                                id="vertical-menu-btn"
                                onClick={this.toggleMenu}
                            >
                                <i className="ri-arrow-left-double-line"></i>
                            </Button>
                        </Grid>
                    </div>
                </header>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { layoutType } = state.Layout;
    return { layoutType };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(withTranslation()(ToggleMenu));
